import { useDetailApi } from "../../../swr/useApi";
import { adminLoyaltyService } from "../../api_client";
import type { LoyaltyStatsDto } from "../../../api";

export function useAdminLoyaltyStats() {
  return useDetailApi<LoyaltyStatsDto>({
    key: "admin-loyalty-stats",
    serviceMethod: async () => await adminLoyaltyService.getStats(),
  });
}
